module.exports = __webpack_public_path__ + "media/images/beauty/card-desktop@2x-e065243584f81b058c4492cfb485612a.jpg";